export const withAliases = <A, B>(component: A, properties: B): A & B => {
  return Object.assign(component, properties);
};
